/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactusContent } from '../../models/contactus-content';
import { ContactusContentApiRespModel } from '../../models/contactus-content-api-resp-model';

export interface ApiMasterContactusContentEditPost$Params {
      body?: ContactusContent
}

export function apiMasterContactusContentEditPost(http: HttpClient, rootUrl: string, params?: ApiMasterContactusContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ContactusContentApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterContactusContentEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContactusContentApiRespModel>;
    })
  );
}

apiMasterContactusContentEditPost.PATH = '/api/Master/ContactusContent/Edit';
